import spinnerIcon from '../icons/film.svg';

import './Spinner.css';

function Spinner() {

    return (
        <figure class="image is-24x24">
            <img  class="spinner" src={spinnerIcon} alt="spinnerIcon" />
        </figure>
    );
}

export default Spinner;